<script setup lang="ts">
import { Dialog, DialogContent, DialogHeader, DialogClose, DialogTrigger } from '@/components/ui/dialog'

const props = defineProps({
    type: {
        type: String,
        default: 'masters'
    }
})
const globalStore = useGlobalStore()
const userStore = useUserStore()

const route = useRoute();

const linkType = computed(() => {
    return props.type === 'masters' ? 'master_category' : 'task_category'
})

const currentSpecificationSlug = ref(<string>route.params.slug);
const currentSpecification = computed(() => globalStore.specifications.find(item => item.slug === currentSpecificationSlug.value))
const parentSpecification = computed(() => globalStore.specifications.find(item => item.documentId === currentSpecification.value?.parent_id) || currentSpecification.value)
const specificationChildList = computed(() => globalStore.childSpecifications(parentSpecification.value?.documentId))
</script>

<template>
    <Dialog class="block md:hidden">
        <DialogTrigger as-child>
            <slot name="trigger" />
        </DialogTrigger>
        <DialogContent class="ys-modal-dialog w-full">
            <DialogHeader class="px-4 py-5 mb-6">
                <p class="mb-1 text-center uppercase text-[13px] tracking-widest">{{ $t('Select category') }}</p>
                <DialogClose class="absolute top-4 ltr:right-4 rtl:left-4">
                    <Icon name="ri:close-line" size="20px" class="text-gray-500 translate-all hover:text-gray-700"/>
                </DialogClose>
            </DialogHeader>

            <ul class="nav px-5 pb-10">
                <li class="my-1">
                    <NuxtLink
                        v-if="parentSpecification"
                        :to="{name: linkType, params: {slug: parentSpecification.slug, city: userStore.currentCity?.slug}}"
                        class="list-container block w-full py-2 px-3 transition-all hover:pl-4 rtl:hover:pr-4"
                        :class="{ list_container_active: parentSpecification.slug == currentSpecificationSlug }">
                        {{ parentSpecification.name }}
                    </NuxtLink>
                </li>
                <li class="my-1 pl-4" v-for="item in specificationChildList">
                    <NuxtLink
                        :to="{name: linkType, params: {slug: item.slug, city: userStore.currentCity?.slug}}"
                        class="list-container block w-full py-2 px-3 transition-all hover:pl-4 rtl:hover:pr-4"
                        :class="{ list_container_active: item.slug == currentSpecificationSlug }">
                        {{ item.name }}
                    </NuxtLink>
                </li>
            </ul>

        </DialogContent>
    </Dialog>
</template>

<style scoped lang="scss">
.list_container_active {
    font-weight: 600;
    border-radius: 8px;
    background: rgba(246, 248, 250, 1);
    transition: 0.5s ease;
}
</style>